import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Authenticated({children, setter, reverse = false, redirect = "/v1/ui/staff/page/signin"}) {
    const navigate = useNavigate();
    const [authenticated, setAuthenticated] = useState(null);

    useEffect(() => {
        fetch('/v1/api/staff/$self')
            .then(response => {
                if (response.ok) {
                    response.json()
                        .then(data => {
                            if (setter) {
                                setter(data);
                            }
                            setAuthenticated(true);
                        }).catch(() => {
                            setAuthenticated(false);
                        });             
                } else {
                    setAuthenticated(false);
                }
            })
            .catch(() => setAuthenticated(false));
    }, [children]);

    // The reverse boolean maybe be confusing, but it is a simple mechanism to
    // flip the authentication workflow. On reverse=false, the content is
    // rendered if authenticated, otherwise the user is redirected.
    // On reverse=true, the oppose is true.
    // The usecase is for:
    // - reverse=false: protect staff pages
    // - reverse=true: only display the sign-in page if not authenticated
    switch (authenticated) {
        case (!reverse):
            return <>{children}</>;
        case (reverse):
            navigate(redirect);
            break;
        default:
            return <h1>Authenticating...</h1>;  
    }
}